import React, { useEffect, useContext} from 'react'
import {Typography, TableRow, TableCell, Button} from '@mui/material'
import {useHelper} from '../hooks/useHelper'
import {v4 as uuidv4} from 'uuid';

export const ETDetalleProducto = ({item,setIdSeleccionado,target,siBorder})=>{
  const index = uuidv4();
  const {formatearMontoMoneda,rangoEdadEvento}= useHelper()
  return <>
 
        <TableRow>
            <TableCell style={{borderBottom: siBorder ? '3px dotted #BC8F8F' : undefined}}>
                <Typography sx={{mb:1}}  variant="h6">{item?.detalle}</Typography>
                <p>{item?.info_adicional}</p>
                <p>{rangoEdadEvento(item)}</p>
                <p>{item.matrimonio ? 'Promo matrimonio':'Entrada Individual'}</p>

            </TableCell>
            <TableCell style={{borderBottom: siBorder ? '3px dotted #BC8F8F' : undefined}}>
                <Button style={{margin:'1rem',whiteSpace: 'nowrap',minWidth:'100px'}} 
                    variant='contained' 
                    color='primary' 
                    onClick={()=>setIdSeleccionado(item)}>
                       {target!='ex' ? 'COMPRAR' : `$ ${formatearMontoMoneda(item.valor_mp)}`}                        
                </Button>
            </TableCell>
    </TableRow>
  </>
}



